import React from "react";
import styled, { css } from "styled-components";
import { transparentize, darken } from "polished";
import { Theme } from "../theme";

export const InputWrapper = styled.div`
  position: relative;
  & input {
    display: block;
    position: relative;
    z-index: 0;
    width: 100%;
    padding: 0 12px;
    height: 42px;
    border: 1px solid #e6e2ef;
    border-radius: 8px;
    background: #fff;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
    &:focus {
      outline: none;
      border: 1px solid ${(props) => props.theme?.PrimaryColor || Theme.PrimaryBlue};
      box-shadow: 0 0 0 3px
        ${transparentize(0.86, Theme.PrimaryBlue)};
    }
    &::placeholder {
      color: ${darken(0, Theme.PrimaryInputOutline)};
    }
    &:disabled {
      background: #f5f3f8;
      border: 1px solid #e6e2ef;
      color: #6b6478;
    }
    ${(props) =>
      props.error &&
      css`
        border: 1px solid ${Theme.PrimaryRed};
        box-shadow: 0 0 0 3px ${transparentize(0.85, Theme.PrimaryRed)};
      `}
  }

  & .type {
    display: inline-flex;
    position: absolute;
    height: 42px;
    z-index: 1;
    width: 36px;
    bottom: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    color: ${darken(0.1, Theme.PrimaryInputOutline)};
  }
`;

export const InputLabel = styled.div`
  margin-bottom: 0.3rem;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #7a738a;
`;

export const InputError = styled.div`
  font-size: 0.7rem;
  font-style: italic;
  text-align: left;
  position: absolute;
  width: 100%;
  bottom: -19px;
  right: 0;
  color: ${Theme.PrimaryRed};
`;
